import { render, staticRenderFns } from "./MoreHotelPriceItem.vue?vue&type=template&id=0a62c632&scoped=true"
import script from "./MoreHotelPriceItem.vue?vue&type=script&lang=js"
export * from "./MoreHotelPriceItem.vue?vue&type=script&lang=js"
import style0 from "./MoreHotelPriceItem.vue?vue&type=style&index=0&id=0a62c632&prod&scoped=true&lang=css"
import style1 from "./MoreHotelPriceItem.vue?vue&type=style&index=1&id=0a62c632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a62c632",
  null
  
)

export default component.exports